import React ,{useState,useEffect,useRef } from 'react';
import styled from 'styled-components';
import ChatingDetail from '../chating/ChatingDetail';
import CommentBarChat from '../fixbar/CommentBarChat';
import serverController from '../../server/serverController';
import chatController from '../../server/chatController';
import { ChatActions } from '../../store/actionCreators';
import { useSelector } from 'react-redux';


export default function Chating({match}) {
    const userInfo = useSelector(state=>{ return state.userInfo}); 
    const chatInfo = useSelector(state=>{ return state.chatInfo}); 

    const [chatCont,setChatCont]= useState("");
    const [lastPos,setLastPos]= useState(0);
    const [areaBottomPadding, setAreaBottomPadding]= useState(0);
    const messagesEndRef = useRef(null)

    const callBack= async (jsonData)=>{
        if(jsonData.success !== 1){
          alert("서버에 문제가 있습니다.");
          return;
        }
        jsonData.data.chats.reverse()
        if(Array.isArray(jsonData.data.chats) && jsonData.data.chats.length > 0)
        {
            setLastPos( jsonData.data.chats[0].no);
        }
        
        await ChatActions.chatUpdate({chatList:  jsonData.data.chats});
        scrollToBottom();
      }
      

    const scrollToBottom = () => {
        if(messagesEndRef.current){
            messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
        }
        
    }

    const onScrollTopCheck = async (e) =>{
        if(e.target.scrollTop === 0 && chatInfo.chatList.length > 0 && lastPos !== 0){
            await serverController.getServerData(`groups/${match.params.group_no}/chat?last_pos_no=${lastPos}`,
            async function(res){
                if(res.success === 1 && res.data && res.data.chats){

                    let list = JSON.parse(JSON.stringify(chatInfo.chatList));
                    let chats = JSON.parse(JSON.stringify(res.data.chats)).reverse();
                    let result = chats.concat(list);
                    
                    if(chats.length === 0){
                        setLastPos(0);
                        return;
                    }

                    setLastPos(result[0].no);
                    var currentHeight = messagesEndRef.current.scrollHeight;
                    await ChatActions.chatUpdate({chatList: result});
                    messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight - currentHeight;
                }

                
            });
        }
    }

    //페이지가 렌더링이 되었을 때 한번 호출
    useEffect(() => {
         serverController.getServerData(`groups/${match.params.group_no}/chat?`,callBack);
         initSocketData();

         return function cleanUp() {
            chatController.disconnectConnection();
         }
    },[]);

    useEffect(() => {
        let newBottomPx = areaBottomPadding+"px";
        messagesEndRef.current.style.paddingBottom = newBottomPx;
    },[areaBottomPadding]);

    let  initSocketData = async () => {
        initSocketConnection();
    }

    const updateChatListRedux = async (data) =>{
        await ChatActions.chatInsert({chatList: data});
        scrollToBottom();
    }

    let initSocketConnection = async () => {
        let roomObj = {};
        roomObj['group_no'] = match.params.group_no;
        roomObj['type'] = 'group_chat';
        await chatController.setGroupChatConnection(roomObj,updateChatListRedux);
    }

    let sendGroupChat = async (params) => {    
        return new Promise(async (resolve, reject) => {
            try
            {
                if(chatCont.length === 0){
                    alert("글자를 입력해주세요");
                    return;
                }

                let form = {};
                form['group_no'] = params['group_no'];
                form['content'] = params['content'];

                await chatController.sendGroupChatMsg(form); 
                setChatCont("");
                resolve(true);
            }
            catch(err)
            {
                console.log(err);
                reject(err);
            }
        });
    }

    const chatSubmit=()=> {
        return new Promise(async (resolve, reject) => {
            try
            {
                let data = {
                    group_no : match.params.group_no,
                    content : chatCont
                };
                await sendGroupChat(data);
                resolve(true);
            }
            catch(err)
            {
                console.log(err);
                reject(err);
            }
        });
    }

    const checkIsStartChat = (index) =>{
        return  index - 1 < 0 || parseInt(chatInfo.chatList[index].user_no) !== parseInt(chatInfo.chatList[index - 1].user_no);
    }

    const compareCurrentTime = (index) =>{
       return  index + 1 >= chatInfo.chatList.length || new Date(chatInfo.chatList[index].modify_date).getMinutes() !== new Date(chatInfo.chatList[index + 1].modify_date).getMinutes()
    }

    const checkIsLastMessageInNearChat = (index) =>{
        return  index + 1 >= chatInfo.chatList.length || parseInt(chatInfo.chatList[index].user_no) !== parseInt(chatInfo.chatList[index + 1].user_no);
    }

    const checkIsNextDay = (index) =>{
        return  (index + 1 >= chatInfo.chatList.length || new Date(chatInfo.chatList[index].modify_date).getDate() !== new Date(chatInfo.chatList[index + 1].modify_date).getDate())
        && new Date(chatInfo.chatList[index].modify_date).getDate() !== new Date().getDate()
    }

    return(
        <Chatingarea id="chatGround" ref={messagesEndRef} onScroll={onScrollTopCheck}>
            <ChatListArea>
                {
                    chatInfo && chatInfo.chatList ? 
                    chatInfo.chatList.map((value,index)=>{

                        return <ChatingDetail 
                                key={`chat-item-index-${index}`}
                                isTime={checkIsLastMessageInNearChat(index) === true ||  compareCurrentTime(index) === true} 
                                isSelf={parseInt(value.user_no) === parseInt(userInfo.id)} 
                                isStart={checkIsStartChat(index)} 
                                isDateChange={checkIsNextDay(index)} 
                                value={value}/>;
                    })
                    :
                    null
                }
            </ChatListArea>
            <CommentBarChat 
                scrollToBottom={scrollToBottom}
                chatSubmit={chatSubmit}
                chatCont={chatCont}
                setChatCont={setChatCont}
                setAreaBottomPadding={setAreaBottomPadding}
            />
        </Chatingarea>
    )
}

const Chatingarea = styled.div`
    background: #f7f7f7;
    height: 100%;
    min-height: 100%;
    padding : calc(100vw*(94.5/375)) 0 calc(100vw*(70/375));
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    overflow-y: scroll;
`


const ChatListArea = styled.div`
    margin-bottom: calc(100vw*(10/375));
`